export default __webpack_public_path__ + "static/media/markus-winkler-byZq8FXicQs-unsplash.39b82cc3.jpg";